var _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpoDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-57ae20f3-680a-4b5a-b831-ed23039941b6",
    "data-name": "art",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-f4109fba-3d3c-45e7-bfcf-d8eff5f821a4",
    x1: 44.34,
    y1: 24.84,
    x2: 80.16,
    y2: 60.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    className: "stop2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    className: "stop1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-f626cd13-7c1f-40dd-84a8-b67915d5591e",
    x1: 68.5,
    y1: 24.5,
    x2: 68.5,
    y2: 38.5,
    xlinkHref: "#uuid-f4109fba-3d3c-45e7-bfcf-d8eff5f821a4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-38f09bf1-7a53-4285-a131-186e72d12e54",
    x1: 37.34,
    y1: 31.84,
    x2: 73.16,
    y2: 67.66,
    xlinkHref: "#uuid-f4109fba-3d3c-45e7-bfcf-d8eff5f821a4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-6cbdd3d0-2cd1-403c-9d77-231009250430",
    x1: 61.5,
    y1: 31.5,
    x2: 61.5,
    y2: 45.5,
    xlinkHref: "#uuid-f4109fba-3d3c-45e7-bfcf-d8eff5f821a4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-743da0ef-561f-4cdf-b0b7-0c15495a5ed0",
    x1: 24.38,
    y1: 44.79,
    x2: 60.21,
    y2: 80.62,
    xlinkHref: "#uuid-f4109fba-3d3c-45e7-bfcf-d8eff5f821a4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-e7f012d7-ef56-46ee-b753-917a3672ab21",
    x1: 54.5,
    y1: 38.5,
    x2: 54.5,
    y2: 52.5,
    xlinkHref: "#uuid-f4109fba-3d3c-45e7-bfcf-d8eff5f821a4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m61.5,24.5h-16c-1.1,0-2,.9-2,2v5h11l14,14v21h5c1.1,0,2-.9,2-2v-26l-14-14Z",
    fill: "url(#uuid-f4109fba-3d3c-45e7-bfcf-d8eff5f821a4)",
    opacity: 0.25,
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m61.5,24.5v12c0,1.1.9,2,2,2h12l-14-14Z",
    fill: "url(#uuid-f626cd13-7c1f-40dd-84a8-b67915d5591e)",
    opacity: 0.25,
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m54.5,31.5h-16c-1.1,0-2,.9-2,2v5h11l14,14v21h5c1.1,0,2-.9,2-2v-26l-14-14Z",
    fill: "url(#uuid-38f09bf1-7a53-4285-a131-186e72d12e54)",
    opacity: 0.5,
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m54.5,31.5v12c0,1.1.9,2,2,2h12l-14-14Z",
    fill: "url(#uuid-6cbdd3d0-2cd1-403c-9d77-231009250430)",
    opacity: 0.5,
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m47.5,38.5h-16c-1.1,0-2,.9-2,2v38c0,1.1.9,2,2,2h28c1.1,0,2-.9,2-2v-26l-14-14Z",
    fill: "url(#uuid-743da0ef-561f-4cdf-b0b7-0c15495a5ed0)",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m47.5,38.5v12c0,1.1.9,2,2,2h12l-14-14Z",
    fill: "url(#uuid-e7f012d7-ef56-46ee-b753-917a3672ab21)",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpoDocuments);
export default __webpack_public_path__ + "static/media/expo_documents.0d7275a1f3d68e1c775068c8b5f148fe.svg";
export { ForwardRef as ReactComponent };